<template>
  <el-form :inline="true" :model="filterForm" class="" size="mini">
    <el-form-item label="测试时间">
      <el-select v-model="filterForm.testTime" style="width: 180px" @change="getRarityList">
        <el-option
          v-for="item in dateOption"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="版本名称">
      <el-select v-model="filterForm.version" style="width: 180px" @change="onVersionChange">
        <el-option
          v-for="item in versionOption"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="测试备注">
      <el-input style="width: 438px" />
    </el-form-item>

    <div>
      <el-form-item label="人物类型">
        <el-select v-model="filterForm.character_type" style="width: 180px" collapse-tags multiple>
          <el-option
            v-for="item in characterTypeOption"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="性别">
        <el-select v-model="filterForm.gender_type" style="width: 180px" collapse-tags multiple>
          <el-option
            v-for="item in genderTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="资源">
        <el-select v-model="filterForm.resource" style="width: 180px" collapse-tags multiple>
          <select-all-option v-model="filterForm.resource" :options="resourceOption" />
          <el-option
            v-for="item in resourceOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </div>

    <div>
      <el-form-item label="质量等级">
        <el-select v-model="filterForm.partQuality" style="width: 180px" collapse-tags multiple>
          <el-option
            v-for="item in qualityLevelOption"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="资源类型">
        <el-select v-model="filterForm.partType" style="width: 180px" collapse-tags multiple>
          <el-option
            v-for="item in partTypeOption"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="品级">
        <el-select v-model="filterForm.rarity" style="width: 180px" collapse-tags multiple>
          <el-option
            v-for="(label, value) in rarityOption"
            :key="value"
            :label="label"
            :value="value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="排序层级">
        <el-select v-model="filterForm.sortLevel" style="width: 180px">
          <el-option value="quality" label="质量等级" disabled />
          <el-option value="partType" label="资源类型" />
          <el-option value="base" label="基础资源" disabled />
        </el-select>
      </el-form-item>

      <el-form-item label="展开层级">
        <el-select v-model="filterForm.expandLevel" style="width: 180px">
          <el-option value="assetId" label="资源ID" />
          <el-option value="quality" label="质量等级" />
          <el-option value="partType" label="资源类型" />
          <!-- <el-option value="base" label="基础资源" /> -->
        </el-select>
      </el-form-item>
    </div>

    <div>
      <el-form-item label="筛选条目">
        <el-select v-model="filterForm.filterItem" style="width: 180px" collapse-tags multiple>
          <el-option
            v-for="item in filterItemOption"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="筛选选项">
        <el-select v-model="filterForm.filterOption" style="width: 180px">
          <el-option label="按阈值" value="1" />
          <el-option label="按等级" value="2" />
        </el-select>
      </el-form-item>

      <el-form-item v-show="filterForm.filterOption == 1" label="筛选阈值">
        <el-input-number
          v-model="filterForm.thresholdStart"
          theme="normal"
          :controls="false"
        ></el-input-number>
        -
        <el-input-number
          v-model="filterForm.thresholdEnd"
          theme="normal"
          :controls="false"
        ></el-input-number>
      </el-form-item>

      <el-form-item v-show="filterForm.filterOption == 2" label="合规等级">
        <el-select v-model="filterForm.grade" style="width: 180px" collapse-tags multiple>
          <el-option label="合规" value="1" />
          <el-option label="不合规" value="2" />
          <el-option label="严重不合规" value="3" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onEnsure">确定</el-button>
        <el-button type="primary" class="ms-1" @click="$emit('exportTable')">导出所选的数据到CSV文件</el-button>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import SelectAllOption from '/src/components/common/select-all-option.vue'

export default {
  emits: ['get-option-done', 'filter', 'exportTable'],

  components: {SelectAllOption},

  data() {
    return {
      filterForm: {
        sortLevel: 'partType',
        expandLevel: 'partType',
        filterItem: [],
        rarity: [],
      },
      versionOption: [],
      dateOption: [],
      characterTypeOption: [],
      genderTypeOption: [],
      resourceOption: [],
      qualityLevelOption: [],
      partTypeOption: [],
      filterItemOption: ['Triangles', 'MaxDrawCalls', 'FX_Triangles', 'AssetBundleSize', 'FxsDrawCalls', 'Hair_DrawCalls', 'Face_DrawCalls', 'Top_DrawCalls', 'Bottom_DrawCalls', 'Shoe_DrawCalls'],
      rarityOption: [],
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    }
  },

  async created() {
    await this.getOption()
    this.$emit('get-option-done', this.filterForm)
  },

  methods: {
    copy(obj) {
      return JSON.parse(JSON.stringify(obj))
    },

    setFormByQuery() {
      const {params, expandLevel} = this.$route.query
      if (params) {
        let {version, testTime, CharacterType, GenderType, partQuality, partType, filterItem, filterOption, grade, range, rarity} = JSON.parse(decodeURIComponent(params))
        
        this.filterForm.version = version
        this.filterForm.testTime = testTime
        this.filterForm.character_type = [CharacterType]
        this.filterForm.gender_type = [GenderType]
        this.filterForm.partQuality = [partQuality]
        this.filterForm.partType = partType.split(',')
        this.filterForm.filterItem = [filterItem]
        this.filterForm.filterOption = filterOption
        this.filterForm.rarity = rarity

        if (grade) {
          this.filterForm.grade = [grade]
        } else {
          this.filterForm.thresholdStart = range[0]
          this.filterForm.thresholdEnd = range[1]
        }
      }

      if (expandLevel) {
        this.filterForm.expandLevel = expandLevel
      }
    },

    async getRarityList() {
      const {version, testTime} = this.filterForm
      const {data} = await axios('memory/resource_rarity_list/', {
        params: {
          project: this.$route.query.project,
          resource_type: 2,
          version,
          scan_time: testTime,
        }
      })
      
      delete data.null
      this.rarityOption = data
      this.filterForm.rarity = []
    },

    async getSubOption() {
      const { data } = await axios(
        `memory/resource_avatar_one_level_options/?project=${this.project}&Versions=${this.filterForm.version}`
      )
      
      this.dateOption = data.result_ScanTime
      this.characterTypeOption = data.result_CharacterType
      this.genderTypeOption = data.result_GenderType.map(item => ({label: item, value: item}))
      this.partTypeOption = data.result_ResourceType
      this.qualityLevelOption = data.result_Quality
      this.resourceOption = data.result_Resource.map(item => ({label: item, value: item}))

      
      this.filterForm.testTime = this.dateOption[0]
      this.filterForm.character_type = this.copy(data.result_CharacterType)
      this.filterForm.gender_type = this.copy(data.result_GenderType)
      this.filterForm.resource = this.copy(data.result_Resource)
      this.filterForm.partQuality = this.copy(data.result_Quality)
      this.filterForm.partType = this.copy(data.result_ResourceType)

      await this.getRarityList()
    },

    async getOption() {
      const {data} = await axios(`memory/resource_avatar_one_level_options/?project=${this.project}`)

      this.versionOption = data.result_Versions
      const {params} = this.$route.query
      if (params) {
        let {version} = JSON.parse(decodeURIComponent(params))
        this.filterForm.version = version
      } else {
        this.filterForm.version = this.versionOption[0]
      }
      
      await this.getSubOption()
      this.filterForm.filterItem = ['Triangles', 'MaxDrawCalls']
      this.filterForm.filterOption = '2'
      this.filterForm.grade = ['1', '2', '3']
      this.setFormByQuery()
    },

    onVersionChange() {
      this.getSubOption()
    },

    onEnsure() {
      this.$router.push({query: {...this.$route.query, expandLevel: this.filterForm.expandLevel}})
      this.$emit('filter', this.filterForm)
    }
  }
}
</script>